import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { genKey } from "../../../../../../helpers/keys.js";
import * as S from "./styled.js";
export const ComarketingMobile = ({ props  })=>{
    const { items =[]  } = props ?? {};
    return /*#__PURE__*/ _jsx(S.ComarketingWrapper, {
        "data-testid": "ComarketingMobile",
        children: items.map((item)=>{
            const resize = {
                width: 460,
                height: 250
            };
            const imgProps = {
                ...item,
                resize
            };
            return /*#__PURE__*/ _createElement(S.ComarketingImage, {
                ...imgProps,
                isLazy: true,
                key: genKey(item)
            });
        })
    });
};
export default ComarketingMobile;

//# sourceMappingURL=index.js.map